/**
 * Parses an RGB string from color sampling and returns a CSS rgb() color value
 * @param rgbString - Expected format: "R:123 G:45 B:67" (from color detection)
 * @returns CSS rgb string (e.g., "rgb(123, 45, 67)") or fallback white color
 */
export const rgbToColor = (rgbString: string): string => {
  const match = rgbString.match(/R:(\d+)\s+G:(\d+)\s+B:(\d+)/);
  if (match) {
    const [, r, g, b] = match;
    return `rgb(${r}, ${g}, ${b})`;
  }
  // Fallback to white if parsing fails
  return 'rgb(255, 255, 255)';
};
